import React, { useState } from 'react';
import {
  CreateVehicleSmartInsightResponse,
  VehicleSmartInsightUserCategoryType,
  userCategoryTypes,
} from '@/api/requests/llm/interfaces';
import { useLLM } from '@/hooks/useLLM';
import { Box } from '@/theme/index';
import { SmartInsightToggleButtons } from './SmartInsightToggleButtons/SmartInsightToggleButtons';
import { SmartInsightUserTips } from './SmartInsightUserTips/SmartInsightUserTips';

export function SmartInsightDetails() {
  const { data: llmResponse } = useLLM('vehicle');
  const typedLLMResponse = llmResponse as CreateVehicleSmartInsightResponse;
  const [currentUserCategoryType, setCurrentUserCategoryType] =
    useState<VehicleSmartInsightUserCategoryType>(userCategoryTypes[0]);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newUserCategory: VehicleSmartInsightUserCategoryType
  ) => {
    if (typedLLMResponse && newUserCategory !== null) {
      setCurrentUserCategoryType(newUserCategory);
    }
  };

  return (
    <Box data-testid="SmartInsightDetails">
      <SmartInsightToggleButtons
        handleChange={handleChange}
        currentUserCategoryType={currentUserCategoryType}
      />
      <SmartInsightUserTips currentUserCategoryType={currentUserCategoryType} />
    </Box>
  );
}
